window.process = {};
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import createStore from "store/createStore";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { SnackbarProvider } from "notistack";
import useUtm from "./hooks/useUtm";
import ratingPopupManager from "./utils/ratingPopupManager";
import userSessionManager from "./utils/userSessionManager";
import getSuspenseFallback from "./utils/suspenseFallback";
import ScrollToTop from "./ScrollTop";
import newRelicService from "./service/newRelicService";
import analyticsManager from "./analytics";
import { api } from "./config/variables";
import "babel-polyfill";
import Error403 from "components/Error403Modal";
import AssignCarrierPopup from "components/AssignCarrierPopup";
import ErrorBoundary from "components/ErrorBoundary";
import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import "./i18n";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const DepotConnect = lazy(() => import("layouts/DepotConnect"));
const Frameless = lazy(() => import("layouts/Framesless"));
const AuthLayout = lazy(() => import("layouts/Auth"));
const AdminLayout = lazy(() => import("layouts/Admin"));
const ClientLayout = lazy(() => import("layouts/Client"));
const SettingsLayout = lazy(() => import("layouts/Settings"));
const PrivateRoute = lazy(() => import("Authorization"));
const AboutLayout = lazy(() => import("layouts/About"));
const PublicLayout = lazy(() => import("layouts/Public"));

const hist = createBrowserHistory({ basename: "/" });

export const store = createStore();

ratingPopupManager.initializeRatingCookie();
userSessionManager.initializeSessionStorage();

if (api.currentEnv === "production" && api.isDev === false) {
	newRelicService.initialize(api.newRelic);
	analyticsManager.initialize();
}

const RootIndex = () => {
	useUtm();

	return (
		<ErrorBoundary>
			<Provider store={store}>
				<SnackbarProvider
					maxSnack={3}
					preventDuplicate
					anchorOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
				>
					<ConnectedRouter history={hist}>
						<Router history={hist}>
							<Suspense fallback={getSuspenseFallback}>
								<Error403 />
								<AssignCarrierPopup />

								<ScrollToTop />
								<Switch>
									<Route path="/auth" component={AuthLayout} />
									<Route path="/admin" component={AdminLayout} />
									<Route path="/about" component={AboutLayout} />
									<Route path="/p" component={PublicLayout} />
									<Route path="/frameless" component={Frameless} />
									<PrivateRoute path="/depot-connect">
										<DepotConnect />
									</PrivateRoute>
									<PrivateRoute path="/client">
										<ClientLayout />
									</PrivateRoute>
									<PrivateRoute path="/settings">
										<SettingsLayout />
									</PrivateRoute>
									<Redirect from="/" to="/client/dashboard" />
								</Switch>
							</Suspense>
						</Router>
					</ConnectedRouter>
				</SnackbarProvider>
			</Provider>
		</ErrorBoundary>
	);
};
ReactDOM.render(<RootIndex />, document.getElementById("root"));
